<div class="wizard-step-content">
  <h3 class="mb-4">
    <i class="fa fa-info-circle text-primary me-2"></i>
    {{ 'eventWizard.basic.title' | translate }}
  </h3>
  <p class="text-muted mb-6">{{ 'eventWizard.basic.subtitle' | translate }}</p>

  <div class="row">
    <h5 class="mb-3">{{ 'eventWizard.basic.eventDetails' | translate }}</h5>
  </div>

  <div class="row g-4 mb-6">
    <div class="col-lg-6 col-12">
      <app-input-component
        [label]="('eventWizard.basic.eventName' | translate) + ' *'"
        [type]="'text'"
        [placeholder]="'eventWizard.basic.eventNamePlaceholder' | translate"
        [value]="eventData.event_name"
        [invalid]="isFieldInvalid('event_name')"
        (valueChange)="emitChange({ event_name: $event })"
      />
      <div *ngIf="isFieldInvalid('event_name')" class="invalid-feedback d-block">
        {{ 'validation.required' | translate }}
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <app-selectorini
        [options]="disciplineOptions"
        [displayKey]="'label'"
        [valueKey]="'value'"
        [value]="eventData.discipline"
        [label]="('eventWizard.basic.category' | translate) + (isDisciplineRequired ? ' *' : '')"
        [placeholder]="'eventWizard.basic.categoryPlaceholder' | translate"
        [invalid]="isFieldInvalid('discipline')"
        (valueChange)="emitChange({ discipline: $event })"
      />
      <div *ngIf="isFieldInvalid('discipline')" class="invalid-feedback d-block">
        {{ 'validation.required' | translate }}
      </div>
    </div>
  </div>

  <div class="row g-4 mb-6">
    <div class="col-12">
      <label class="form-label fw-semibold">{{ 'eventWizard.basic.eventDescription' | translate }}</label>
      <app-markdown-editorini
        [value]="eventData.event_description"
        (valueChange)="emitChange({ event_description: $event })"
      />
    </div>
  </div>

  <div class="row">
    <h5 class="mb-3">{{ 'eventWizard.basic.dateTime' | translate }}</h5>
  </div>

  <div class="row g-4 mb-6">
    <div class="col-lg-4 col-12">
      <app-input-component
        [label]="('eventWizard.basic.startDate' | translate) + ' *'"
        [type]="'datetime-local'"
        [placeholder]="'eventWizard.basic.startDatePlaceholder' | translate"
        [value]="eventData.start_date"
        [invalid]="isFieldInvalid('start_date')"
        (valueChange)="emitChange({ start_date: $event })"
      />
      <div *ngIf="isFieldInvalid('start_date')" class="invalid-feedback d-block">
        {{ 'validation.required' | translate }}
      </div>
    </div>
    <div class="col-lg-4 col-12">
      <app-input-component
        [label]="('eventWizard.basic.endDate' | translate) + ' *'"
        [type]="'datetime-local'"
        [placeholder]="'eventWizard.basic.endDatePlaceholder' | translate"
        [value]="eventData.end_date"
        [invalid]="isEndDateInvalid()"
        (valueChange)="emitChange({ end_date: $event })"
      />
      <div *ngIf="isFieldInvalid('end_date')" class="invalid-feedback d-block">
        {{ 'validation.required' | translate }}
      </div>
      <div *ngIf="showValidation && eventData.end_date && eventData.start_date && !isFieldInvalid('end_date') && isEndDateInvalid()" class="invalid-feedback d-block">
        {{ 'validation.endDateBeforeStartDate' | translate }}
      </div>
    </div>
    <div class="col-lg-4 col-12">
      <app-input-component
        [label]="'eventWizard.basic.registrationDeadline' | translate"
        [type]="'datetime-local'"
        [placeholder]="'eventWizard.basic.registrationDeadlinePlaceholder' | translate"
        [value]="eventData.registration_deadline"
        [invalid]="isRegistrationDeadlineInvalid()"
        (valueChange)="emitChange({ registration_deadline: $event })"
      />
      <div *ngIf="isRegistrationDeadlineInvalid()" class="invalid-feedback d-block">
        {{ 'validation.deadlineAfterStartDate' | translate }}
      </div>
    </div>
  </div>

  <div class="row">
    <h5 class="mb-3">{{ 'eventWizard.basic.location' | translate }}</h5>
  </div>

  <div class="row g-4 mb-6">
    <div class="col-lg-6 col-12">
      <app-input-component
        [label]="('eventWizard.basic.address' | translate) + ' *'"
        [placeholder]="'eventWizard.basic.addressPlaceholder' | translate"
        [type]="'text'"
        [value]="eventData.address"
        [invalid]="isFieldInvalid('address')"
        (valueChange)="emitChange({ address: $event })"
      />
      <div *ngIf="isFieldInvalid('address')" class="invalid-feedback d-block">
        {{ 'validation.required' | translate }}
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <app-input-component
        [label]="('eventWizard.basic.postalCode' | translate) + ' *'"
        [placeholder]="'eventWizard.basic.postalCodePlaceholder' | translate"
        [type]="'text'"
        [value]="eventData.postal_code"
        [invalid]="isFieldInvalid('postal_code')"
        (valueChange)="emitChange({ postal_code: $event })"
      />
      <div *ngIf="isFieldInvalid('postal_code')" class="invalid-feedback d-block">
        {{ 'validation.required' | translate }}
      </div>
    </div>
  </div>

  <div class="row g-4 mb-6">
    <div class="col-lg-6 col-12">
      <app-input-component
        [label]="('eventWizard.basic.city' | translate) + ' *'"
        [placeholder]="'eventWizard.basic.cityPlaceholder' | translate"
        [type]="'text'"
        [value]="eventData.city"
        [invalid]="isFieldInvalid('city')"
        (valueChange)="emitChange({ city: $event })"
      />
      <div *ngIf="isFieldInvalid('city')" class="invalid-feedback d-block">
        {{ 'validation.required' | translate }}
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <app-selectorini
        [options]="countries"
        [displayKey]="'name'"
        [valueKey]="'country_id'"
        [value]="eventData.country_id"
        [label]="('eventWizard.basic.country' | translate) + ' *'"
        [placeholder]="'eventWizard.basic.countryPlaceholder' | translate"
        [searchable]="true"
        [invalid]="isFieldInvalid('country_id')"
        (valueChange)="emitChange({ country_id: $event })"
      />
      <div *ngIf="isFieldInvalid('country_id')" class="invalid-feedback d-block">
        {{ 'validation.required' | translate }}
      </div>
    </div>
  </div>

  <div class="row">
    <h5 class="mb-3">{{ 'eventWizard.basic.settings' | translate }}</h5>
  </div>

  <div class="row g-4 mb-6">
    <div class="col-lg-4 col-12">
      <app-selectorini
        [options]="currencyOptions"
        [displayKey]="'name'"
        [valueKey]="'code'"
        [value]="eventData.default_currency"
        [label]="('eventWizard.basic.currency' | translate) + ' *'"
        [placeholder]="'eventWizard.basic.currencyPlaceholder' | translate"
        (valueChange)="emitChange({ default_currency: $event })"
      />
      <small class="text-muted">{{ 'eventWizard.basic.currencyHint' | translate }}</small>
    </div>
  </div>

  <div class="row">
    <h5 class="mb-3">{{ 'eventWizard.basic.images' | translate }}</h5>
  </div>

  <div class="row g-4">
    <div class="col-lg-6 col-12">
      <label class="form-label fw-semibold">{{ 'eventWizard.basic.eventLogo' | translate }}</label>
      <app-fileorini
        [accept]="'image/*'"
        (filesChanged)="onLogoChange($event)"
      />
    </div>
    <div class="col-lg-6 col-12">
      <label class="form-label fw-semibold">{{ 'eventWizard.basic.headerImage' | translate }}</label>
      <app-fileorini
        [accept]="'image/*'"
        (filesChanged)="onHeaderChange($event)"
      />
    </div>
  </div>
</div>
